<template>
    <div>
    <s-modal
        title="Reinitialisation du tirage"
        @close="cancelReinit"
        :close="true"
        :open="open">
        <div  style="width: 100%;text-align:center" >
            <s-button icon="ban" theme="is-danger is-medium" label="Annuler le tournoi" 
                @onclick="cancelTournoiModal=true"
                :disabled="forceDate==-1"
            />
            <div v-show="forceDate==-1">
                <s-l id="impossible_annuler">Vous ne pouvez plus annuler le tournoi<br/>Ce tournoi a été démarré à une date antérieure à aujourd'hui.</s-l>

            </div>
            &nbsp;
        </div>
        <div style="text-align:center;margin-top:10px;color:black"  v-if="parties && !tournoi.options.GG">
            <div class="title is-4">OU<br/>
                <s-l id="reinitialiser_partie">Réinitialiser le tirage des parties à partir de :</s-l>
            </div>
            <div >
                    <s-l id="reinitialiser_partie_explain">(Attention les équipes où il y a un score ne seront pas réinitialisées.)</s-l>
            </div>
            <div v-for="(partie, index) in parties" style="margin-bottom: 10px">
                    <s-button 
                        :label="'la partie '+(index+1)"
                        icon=""
                        theme="is-primary is-medium"
                        @onclick="openConfirmReinit(index)"
                        :disabled="partie.state=='FINISH'"
                    />
            </div>
        
        </div>
        <s-confirm
        title="Reiniliser les parties"
        @yes="reinitialiser()"
        @no="modalConfirmReinit=false"
        :open="modalConfirmReinit"
        >
            <div style="color:black">
            <s-l id="confirmReinit" :v="reinitIndexPartie + 1">Vous vous préparez à réinitialiser toutes les parties à partir de la partie %v</s-l>
            
            </div>
        </s-confirm>
        <s-confirm title="Annuler le tournoi"
            @yes="cancelTournoi"
            @no="cancelTournoiModal=false"
            :open="cancelTournoiModal">
            <div class="notification is-danger">
                Annuler le tournoi signifie  :<br/><br/>
                <ol>
                    <li>d'annuler les tirages </li>
                    <li> de perdre les scores et le classement</li>
                    <li> et de revenir aux inscriptions</li>
                </ol>
            </div>
            <div class="notification is-danger">
                Confirmez vous l'annulation ?
            </div>
        </s-confirm>
    </s-modal>
    
    </div>
</template>
<script>
export default {
    props: ["open", 'parties', 'tournoi'],
    data() {
        return {
            cancelTournoiModal: false,
            modalConfirmReinit: false,
            reinitIndexPartie: false
        }
    },
    computed: {
        forceDate: {
            get() {
                var today = new Date();
                var startNumeric = this.$dateToYYYYMMDD(this.tournoi.date);
                var todayNumeric = this.$dateToYYYYMMDD(today);
                if (startNumeric == todayNumeric)
                    return 0;
                else {
                    var returnForceDate = 1;
                    if (typeof(this.tournoi.start)!="undefined")
                        if (this.tournoi.start!=null) {
                            var startNumeric = this.$dateToYYYYMMDD(this.tournoi.start);
                            if (todayNumeric > startNumeric)
                                returnForceDate = -1;
                            }
                    return returnForceDate;
                }
                    
            }
        },
    },
    methods: {
       cancelReinit() {
             this.$emit("close");
        },
         
      openConfirmReinit(index) {
            this.reinitIndexPartie = index;
            this.modalConfirmReinit = true;
        },
      reinitialiser() {
            this.$emit("activeBuger");
            this.$emit("reinitialiser", this.reinitIndexPartie);
            this.modalConfirmReinit=false;
        },
      cancelTournoi() {
            
            if (typeof(this.tournoi.saison)!="undefined") {
                if (this.tournoi.saison != null)
                    tournoi_fct.object.deaffectJoueursSaison(this.club, this.tournoi, ()=>{
                        this.$emit("setState","INSCRIPTION");
                    })
            }
            else {
               
                this.$emit("setState","INSCRIPTION");
            }
                
        },
    }
}

</script>